{
  "title": "Welcome back, <userName/>",
  "titleWithoutName": "Welcome back",
  "entitiesInView": {
    "multiple": "Viewing multiple entities",
    "single": "Viewing {{name}}",
    "allEntities": "Viewing all entities"
  },
  "dashboardCards": {
    "pendingPaymentApprovals": "Pending payment approvals",
    "awaitingFxBooking": "Awaiting FX booking",
    "pendingBalanceTransfers": "Pending balance transfers",
    "pendingBeneficiaryApprovals": "Pending beneficiary approvals",
    "tooltips": {
      "notBatchCount": "Previously shown as batch count. Now showing total number of payments requiring action."
    }
  },
  "balancesCard": {
    "title": "Balances",
    "description": "An aggregated view of your held funds",
    "accounts": "{{accounts}} Accounts",
    "entities": "{{entities}} Entities",
    "maxShown": "Max. 10 currencies shown. To see more click 'View all'"
  },
  "transactionsCard": {
    "title": "Recent Transactions",
    "description": "Review your latest transactions across your entities",
    "maxShown": "Max. 10 transactions shown. To see more click 'View all'"
  },
  "buttons": {
    "createPayments": "Create Payments"
  }
}
